// src/common/utils/functions/getItemDisplayText.ts

import { SaleItemInterface } from "../../types/types";
import { unitTypeToShort } from "./enumToText";

export const getItemDisplayText = (item: SaleItemInterface): string => {
  if (!item.attributes || item.attributes.length === 0) return item.name;

  const attrs = item.attributes
    .filter((attr) => attr.isRequired)
    .map((attr) => {
      if (attr.fieldType === 0 || attr.fieldType === 1 || attr.valueType === 1) {
        let val = String(attr.value);
        if (attr.unit !== undefined && attr.unit !== -1) {
          val += ` ${unitTypeToShort(attr.unit)}`;
        }
        return `${attr.name}: ${val}`;
      }
      return null;
    })
    .filter(Boolean);

  return attrs.length > 0 ? `${item.name} (${attrs.join(", ")})` : item.name;
};